import { DynamicField } from '@cargos/sprintpay-models';

export class BdpFacilityConfig {
    getConfigDynamicField(): DynamicField[] {
        return [
            {
                name: 'customerRef',
                label: 'PO Number (Customer reference)',
                validations: [
                    {
                        id: 2,
                        name: 'required',
                        message: 'Please enter your PO or customer reference #.',
                        value: 'true',
                        title: null,
                        type: 'VALIDATION',
                    },
                ],
            },
        ];
    }
}
